export default "8068ff170fa886f2.png"